// extracted by mini-css-extract-plugin
export default {"loader":"climbing_stairs_loader__OC0b7","loading-bounce":"climbing_stairs_loading-bounce__PJ8Z0","loading-step":"climbing_stairs_loading-step__8NIsw"};